import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import FormMultiplier from '../../../../BaseModule/Components/Form/Components/FormMultiplier/FormMultiplier';
import WizardChildren from '../../WizardChildren';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.MULTIPLIER }>;
	onSubmit: (values: object) => void;
}

const WizardMultiplier: React.FC<Props> = ({ item, onSubmit }) => {
	return (
		<FormMultiplier
			name={item.key}
			createDefault={item.settings?.createDefault}
			max={item.settings?.max}
			min={item.settings?.min}
			addButtonTitle={item.settings?.addButtonTitle}
		>
			{item.children.map(child => (
				<WizardChildren key={child.id} item={child} onSubmit={onSubmit} />
			))}
		</FormMultiplier>
	);
};

export default WizardMultiplier;
